import { Chip } from '@mui/material';
import { getContractStatusColor, mapDatabaseStatusToDisplay } from '../../domain/contractStatus';

const ContractStatusChip = ({ status }: { status: string | null | undefined }) => (
    <Chip
        label={mapDatabaseStatusToDisplay(status)}
        color={getContractStatusColor(status)}
        size="small"
    />
);

export default ContractStatusChip;
